export const driveConstants = {
  DRIVE_LOAD_DATA_REQUEST: 'DRIVE_LOAD_DATA_REQUEST',
  DRIVE_LOAD_DATA_SUCCESS: 'DRIVE_LOAD_DATA_SUCCESS',
  DRIVE_LOAD_DATA_FAILURE: 'DRIVE_LOAD_DATA_FAILURE',

  DRIVE_SET_SUBMENU: 'DRIVE_SET_SUBMENU',
};